import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-police',
  templateUrl: './privacy-police.component.html',
  styleUrls: ['./privacy-police.component.css']
})
export class PrivacyPoliceComponent {
    public markdown = '## Privacy Police';
}
